import { render } from "./NewDocumentsMain.vue?vue&type=template&id=7083d43a&scoped=true"
import script from "./NewDocumentsMain.vue?vue&type=script&lang=js"
export * from "./NewDocumentsMain.vue?vue&type=script&lang=js"

import "./NewDocumentsMain.vue?vue&type=style&index=0&id=7083d43a&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7083d43a"]])

export default __exports__